import React from 'react';
import ImmutableUnderReviewFormControl from '../reviewEditControls/ImmutableUnderReviewFormControl';
import { DatePicker, MonthPicker } from '.';
import { SHOW_KICK_OFF_DATES } from '@rd-web-markets/market/dist/constants';

/**
 * @param {string} datePickerType - one of month | date
 */

const ProjectReportDateColumns = _ref => {
  let {
    disabled,
    report,
    handleProjectReportChange,
    index,
    datePickerType = 'month'
  } = _ref;
  const DatePickerComponent = datePickerType === 'month' ? MonthPicker : DatePicker;
  const checkAndHandleDates = (name, date) => {
    handleProjectReportChange({
      target: {
        value: date,
        name: name
      }
    }, index);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, SHOW_KICK_OFF_DATES && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: DatePickerComponent,
    disabled: disabled,
    selected: report.kick_off_project_w_customer,
    onChange: date => checkAndHandleDates('kick_off_project_w_customer', date)
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: DatePickerComponent,
    disabled: disabled,
    selected: report.bsfz_submission_target_date,
    onChange: date => checkAndHandleDates('bsfz_submission_target_date', date)
  }))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: DatePickerComponent,
    disabled: disabled,
    selected: report.start_date,
    onChange: date => checkAndHandleDates('start_date', date)
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: DatePickerComponent,
    disabled: disabled,
    selected: report.end_date,
    onChange: date => checkAndHandleDates('end_date', date)
  }))));
};
export default ProjectReportDateColumns;